import { Component } from "solid-js";

interface PharmacyIconProps {
  class?: string;
}

export const PharmacyIcon: Component<PharmacyIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M2.66667 4.14667V26.6667"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.66675 11.56H6.66675"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.6667 26.6667H9.33341C7.86008 26.6667 6.66675 25.4733 6.66675 24V6.66667C6.66675 5.19333 7.86008 4 9.33341 4H26.6667C28.1401 4 29.3334 5.19333 29.3334 6.66667V24C29.3334 25.4733 28.1401 26.6667 26.6667 26.6667Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.66675 20.44H6.66675"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6667 17.9173H15.4161V22.6667H20.5841V17.9173H25.3334V12.7493H20.5841V8H15.4161V12.7493H10.6667L10.6667 17.9173Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
